const preloaded = window.hammick || {}

export default {
  title: preloaded.title,
  description: preloaded.description,
  commissions: [],
  projects: [],
  pages: {
    contact: preloaded.contact || false,
    home: preloaded.home || false
  },
  imageZoomActive: false,
  ready: false,
  imgReady: false
}



// WEBPACK FOOTER //
// ./src/store/state.js